/* eslint-disable prettier/prettier */
export default class CopyTool {
    constructor({
        copyClassName,
        geometry
    }) {
        this._copyClassName = copyClassName;
        this._geometry = geometry
    }

    onAdd(map) {
        this._map = map;

        const createButton = (className, title, onClick) => {
            const btn = document.createElement("button");
            btn.className = `mapbox-gl-draw_ctrl-draw-btn ${className || ""}`;
            btn.type = "button";
            btn["aria-label"] = title;
            btn.setAttribute("title", title);
            btn.onclick = onClick;

            return btn;
        };

        const selectBtn = createButton(
            this._copyClassName,
            "Copy geometry to clipboard",
            () => {

                this.clearSelection();
                navigator.clipboard.writeText(JSON.stringify(this._geometry[0]));
                this.clearSelection();
            }
        );

        const container = document.createElement("div");
        container.className = "mapboxgl-ctrl-group mapboxgl-ctrl";
        container.appendChild(selectBtn);

        this._container = container;
        this._selectBtn = selectBtn;

        return this._container;
    }

    clearSelection() {
        if (window.getSelection) {
          if (window.getSelection().empty) {
            // Chrome
            window.getSelection().empty(); // clear current selection
          } else if (window.getSelection().removeAllRanges) {
            // Firefox
            window.getSelection().removeAllRanges(); // clear current selection
          }
        } else if (document.selection) {
          // IE?
          document.selection.empty(); // clear current selection
        }
      }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}
